<template>
  <div class="historyDetails">
    <Nav :title="title" :back="back"></Nav>
    <div class="loading" v-if="isLoad">
      <img src="./../../assets/takingCar/loading.gif" alt="" />
    </div>
    <div v-if="!isLoad">
      <div
        class="tip isInvoice"
        v-if="historyDetailsData.status == 3"
        :class="{ isIosx: isiOSX }"
      >
        <p class="left">
          <img src="./../../assets/takingCar/finish.png" alt />
          <span>已开票</span>
        </p>
        <p class="right">电子发票已发送至您的邮箱</p>
      </div>
      <div
        class="tip noInvoice"
        v-if="historyDetailsData.status == 2"
        :class="{ isIosx: isiOSX }"
      >
        <p class="left">
          <img src="./../../assets/takingCar/wait.png" alt />
          <span>申请中</span>
        </p>
        <p class="right">电子发票稍后将发至您的邮箱</p>
      </div>
      <div
        class="tip erre"
        v-if="historyDetailsData.status == 4"
        :class="{ isIosx: isiOSX }"
      >
        <p class="left">
          <img src="./../../assets/takingCar/erro.png" alt />
          <span>开票失败</span>
        </p>
        <p class="right">请核对您提交的信息</p>
      </div>
      <div
        class="tip erre"
        v-if="historyDetailsData.status == 5"
        :class="{ isIosx: isiOSX }"
      >
        <p class="left">
          <img src="./../../assets/takingCar/erro.png" alt />
          <span>开票作废</span>
        </p>
        <p class="right">已退款，此发票作废 </p>
      </div>
      <div class="content">
        <div class="in invoiceInformation">
          <h2>发票信息</h2>
          <p>
            开票平台：
            <span>{{ platform.platform_name }}</span>
          </p>
          <p>
            发票抬头：
            <span>{{ historyDetailsData.invoice_title }}</span>
          </p>
          <p v-if="isCompany">
            发票税号：
            <span>{{ historyDetailsData.tax_num }}</span>
          </p>
          <p>
            发票内容：
            <span>{{ historyDetailsData.content }}</span>
          </p>
          <div v-if="isCompany">
            <span> 更多信息：</span>
            <div>
              <p
                v-if="
                  historyDetailsData.address == null &&
                  historyDetailsData.company_phone == null &&
                  historyDetailsData.open_bank == null &&
                  historyDetailsData.bank_account == null &&
                  historyDetailsData.remark == null
                "
              >
                无
              </p>
              <p v-if="historyDetailsData.address != null">
                {{ historyDetailsData.address }}
              </p>
              <p v-if="historyDetailsData.company_phone != null">
                {{ historyDetailsData.company_phone }}
              </p>
              <p v-if="historyDetailsData.open_bank != null">
                {{ historyDetailsData.open_bank }}
              </p>
              <p v-if="historyDetailsData.bank_account != null">
                {{ historyDetailsData.bank_account }}
              </p>
              <p v-if="historyDetailsData.remark != null">
                {{ historyDetailsData.remark }}
              </p>
            </div>
          </div>
          <p>
            发票金额：
            <span>{{ historyDetailsData.amount | moneyFormat }}元</span>
          </p>
          <p>
            申请时间：
            <span>{{ historyDetailsData.created_at }}</span>
          </p>
        </div>
        <div class="in journeyInformation" @click="goToSeeDetail">
          <h2>行程信息</h2>
          <p>
            1张发票，含{{ historyDetailsData.trip_count }}个行程
            <img src="./../../assets/takingCar/moreright.png" alt />
          </p>
        </div>
        <div class="in">
          <h2>收件信息</h2>
          <p>
            电子邮箱：
            <span>{{ historyDetailsData.email_address }}</span>
          </p>
        </div>
      </div>
      <div class="btn" v-if="historyDetailsData.status == 4">
        <a
          :href="'tel:' + historyDetailsData.service_phone"
          @click="iOStel(historyDetailsData.service_phone)"
          class="right"
        >
          <button>联系客服</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "发票详情",
      isiOSX: false,
      isInvoice: true, //开票是否完成
      isCompany: true, //是否是企业发票
      id: 0,
      historyDetailsData: {},
      platform: {},
      back: 0,
      isLoad:true
    };
  },
  components: { Nav },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(to);
      console.log(from);
      if (from.path == "/takingCar/invoiceHistory") {
        vm.back = 0;
        sessionStorage.setItem("back", "0");
      } else if (from.path == "/takingCar/journeyInformation") {
        if (sessionStorage.getItem("back") == "1") {
          vm.back = 1;
        } else {
          vm.back = 0;
        }
      } else {
        vm.back = 1;
        sessionStorage.setItem("back", "1");
      }
    });
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
    } else {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    }
    this.id = this.$route.query.id;
    this.gethistoryDetailsData();
  },
  filters: {
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  methods: {
    // 获取开票详情
    gethistoryDetailsData() {
      this.$api
        .post("/taxis/member/invoice/history/detail", {
          id: this.id,
        })
        .then((res) => {
          this.isLoad = false;
          // console.log(res);
          this.historyDetailsData = res;
          this.platform = res.platform;
          if (res.title_type == 1) {
            // 个人
            this.isCompany = false;
          } else if (res.title_type == 2) {
            // 公司
            this.isCompany = true;
          }
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    iOStel(phoneString) {
      // console.log(phoneString);
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
        this.phone(phoneString);
      }
    },
    phone(phoneString) {
      this.tel = phoneString;
      this.params(this.tel, this.tel, "phone");
    },
    goToSeeDetail() {
      this.$router.push({
        path: "/takingCar/journeyInformation",
        query: {
          external_order_sn_s: this.historyDetailsData.external_order_sn_s,
        },
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.historyDetails {
  background: #ffffff;
  height: 100%;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .tip {
    height: 18px;
    font-size: 13px;
    line-height: 18px;
    margin: 70px 15px 0;
    padding: 9px 10px;
    overflow: hidden;
    border-radius: 3px;
    .left {
      float: left;
      font-weight: bold;
      img {
        width: 16px;
        height: 16px;
        transform: translateY(3px);
        margin-right: 8px;
      }
    }
    .right {
      float: right;
    }
  }
  .isIosx {
    margin: 90px 15px 0;
  }
  .isInvoice {
    background: #f1fbf3;
    color: #3eb24e;
  }
  .noInvoice {
    background: #fff7e4;
    color: #b78100;
  }
  .erre {
    background: #ffe7e1;
    color: #f0441c;
  }
  .content {
    margin: 0 15px;
    .in {
      color: #666666;
      font-size: 15px;
      line-height: 21px;
      h2 {
        color: #333333;
        font-size: 17px;
        line-height: 24px;
        margin: 21px 0;
      }
      p {
        margin-bottom: 15px;
        display: flex;
        span {
          margin-left: 20px;
          flex: 1;
        }
      }
    }
    .invoiceInformation {
      border-bottom: 0.5px solid #dddddd;
      div {
        margin-bottom: 15px;
        display: flex;
        overflow: hidden;
        span {
          min-width: 75px;
        }
        div {
          margin-left: 21px;
          margin-bottom: 0;
          flex-direction: column;
          display: flex;
          flex-flow: wrap;
          p {
            width: 100%;
            margin-bottom: 5px;
            word-wrap: break-word;
          }
          p:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }
    .journeyInformation {
      border-bottom: 0.5px solid #dddddd;
      background: #ffffff;
      p {
        overflow: hidden;
        img {
          float: right;
          width: 8.5px;
          height: 8.5px;
          margin-top: 6px;
        }
      }
    }
  }
  .btn {
    width: 90%;
    height: 50px;
    margin: 76px auto 50px;
    button {
      width: 100%;
      height: 50px;
      background: #181818;
      color: #ffffff;
      font-size: 18px;
      line-height: 25px;
      border: none;
      border-radius: 3px;
    }
  }
}
</style>
